'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useOrgNavigate } from '@/hooks/use-app-navigate';

interface SubscriptionResourceBadgeProps {
  subscriptionId: string;
  amount?: number;
  currency?: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * SubscriptionResourceBadge component for displaying subscription information
 * Inherits from generic ResourceBadge
 */
export function SubscriptionResourceBadge({
  subscriptionId,
  variant = 'secondary',
  className,
}: SubscriptionResourceBadgeProps) {
  const { orgRoutes } = useOrgNavigate();

  return (
    <ResourceBadge
      name="subscription"
      value={`${subscriptionId.substring(0, 8)}...`}
      appLink={orgRoutes.SUBSCRIPTION_DETAILS(subscriptionId)}
      variant={variant}
      className={className}
    />
  );
}
